<template>
  <div id="app" v-if="show">
    <router-view />
  </div>
</template>

<script>
// 侧边栏点击
export default {
  data() {
    return {
      show: false,
    };
  },
  // # 外大PC端官网
  // VUE_APP_CUFA_PC = 'http://192.168.1.101:8140/'
  mounted() {
    // 引入53客服
    let _head = document.querySelectorAll("head")[0];
    let script = document.createElement("script");
    script.src = "//tb.53kf.com/code/code/b48a6d9b24a8fba55ca6210e9cad74971/7";
    process.env.NODE_ENV == "production" ? _head.appendChild(script) : null;
    // 获取IP
    // this.$axios
    //   .get("http://ip-api.com/json/?lang=zh-CN")
    //   .then((res) => {
    //     const data = res.data.query;
    //     sessionStorage.setItem("currentIp", data);
    //   })
    //   .finally(() => {
    //     // 获取来源基本信息
    //     this.$axios
    //       .post("/trip/InfoSources/AddWebsiteView", {
    //         IP: sessionStorage.getItem("currentIp")
    //           ? sessionStorage.getItem("currentIp")
    //           : "0.0.0.0",
    //         MenuName: document.referrer == "" ? "秋溪概况" : document.referrer,
    //         Origin: 239,
    //       })
    //       .then((res) => {
    //         // console.log(res);
    //       });
    //   });
	if (!sessionStorage.getItem("currentIp") || !sessionStorage.getItem("currentCity"))
	{
	  try{
	  	var data = {
	  		key: "F6TBZ-EPVCU-Z4QV4-4A3MT-IRJLZ-DXFJ4"  //这个key就是你申请的密钥
	  	};
	  	var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
	  	data.output = "jsonp";
	  	this.$jsonp(url, data)
	  	.then(res => {
	
	  	  sessionStorage.setItem("currentIp", res.result.ip);
	  	  sessionStorage.setItem("currentCity", res.result.ad_info.city);
	  	  // this.userIp = res.result.ip
	
	
	  	})
	  	.catch(error => {
	  		//console.log(error);
	
	  	});
	  }catch (e) {
	  	sessionStorage.setItem("currentIp", '未知');
	  	sessionStorage.setItem("currentCity", '其他');
	  	//console.log(this.userIp+this.systemInfo+'ip出错')
	  }
	}
    window.addEventListener("resize", () => {
      const _width = window.innerWidth;
      if (_width >= 850) {
        window.location.href =
          process.env.VUE_APP_DG_PC +
          window.location.pathname.substring(1) +
          window.location.search;
      }
    });
  },
  created() {
    setTimeout(() => {
      if (this.$route.query.source) {
        this.show = true;
      } else {
        if (
          !navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          )
        ) {
          if (window.location.search) {
            window.location.href =
              process.env.VUE_APP_DG_PC +
              window.location.pathname.substring(1) +
              window.location.search;
          } else {
            window.location.href =
              process.env.VUE_APP_DG_PC +
              window.location.pathname.substring(1);
          }
        } else {
          this.show = true;
        }
      }
    }, 350);
  },
};
</script>>
<style lang="scss">
#app {
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background-color: #fff;
  // max-width: 750px;
  // margin: 0 auto;
}
</style>
